import { Alert, Button, Stack, Text, Title } from "@mantine/core";

import { AuthPageFrame } from "./AuthPageFrame.js";

export function AccessPending({ onRefresh }: { readonly onRefresh: () => void }) {
  return (
    <AuthPageFrame>
      <Stack gap="md">
        <Title order={1}>Access pending</Title>
        <Alert color="blue" title="Your account is signed in">
          An administrator must grant you access before reports can be shown.
        </Alert>
        <Text c="dimmed">
          Refresh after your access has been granted. No report data is requested
          while access is pending.
        </Text>
        <Button onClick={onRefresh} variant="light">
          Refresh access
        </Button>
      </Stack>
    </AuthPageFrame>
  );
}
